import type { IBlackbaudUnsubscribeSyncPreference } from '@feathr/blackbox';
import { EBlackbaudRaisersEdgeUnsubscribeSyncActions } from '@feathr/blackbox';
import type { TIntegrationUISettingValue, TIntegrationUISettingValues } from '@feathr/components';

import { SOLICIT_CODE_KEY, UNSUBSCRIBE_ACTION_KEY } from '../../raisersEdgeConfig';

/** The preference an integration holds before the customer picks one. */
export const DEFAULT_UNSUBSCRIBE_PREFERENCE: IBlackbaudUnsubscribeSyncPreference = {
  action: EBlackbaudRaisersEdgeUnsubscribeSyncActions.DoNotSync,
};

/** The unsubscribe preference as settings panel values, keyed by field key. */
export function getUnsubscribeValues({
  action,
  solicit_code: solicitCode,
}: IBlackbaudUnsubscribeSyncPreference): TIntegrationUISettingValues {
  return {
    [UNSUBSCRIBE_ACTION_KEY]: action,
    ...(solicitCode && { [SOLICIT_CODE_KEY]: solicitCode }),
  };
}

/** The preference with one settings field applied. An action change keeps `solicit_code`, as v1 did. */
export function updateUnsubscribePreference(
  preference: IBlackbaudUnsubscribeSyncPreference,
  key: string,
  value: TIntegrationUISettingValue,
): IBlackbaudUnsubscribeSyncPreference {
  if (typeof value !== 'string') {
    return preference;
  }

  switch (key) {
    case UNSUBSCRIBE_ACTION_KEY:
      return { ...preference, action: value as EBlackbaudRaisersEdgeUnsubscribeSyncActions };

    case SOLICIT_CODE_KEY:
      return { ...preference, solicit_code: value };

    default:
      return preference;
  }
}
